import React, { useState, useEffect } from 'react';
import './preloader.css';
import preload from './../../assets/preload.png';

const Preloader = () => {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isLoading && (
        <div className="preloader">
          <div className="image-container">
            <img
              src={preload}
              alt="Loading Collage"
            />
          </div>
          <p>
            ..تحميل

          </p>
        </div>
      )}
    </>
  );
};

export default Preloader;